import { render, staticRenderFns } from "./detail-component-exchanges.vue?vue&type=template&id=7e0b7f86&scoped=true"
import script from "./detail-component-exchanges.vue?vue&type=script&lang=ts"
export * from "./detail-component-exchanges.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0b7f86",
  null
  
)

export default component.exports